import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InlineSelect, MenuItem, Tooltip, Typography } from 'seagull';
import { getOccurrenceLabel, getOccurrenceOptionTooltip, getTriggerLabel } from './useBillingInitiationControl';
export function renderBillingInitiationMenuItem(param) {
    let { value, text, subtext, testId, disabled, tooltipProps, isMobileDevice } = param;
    return /*#__PURE__*/ _jsxs(MenuItem, {
        value: value,
        variant: "multiline",
        testId: testId,
        style: isMobileDevice ? undefined : {
            maxWidth: 330,
            minWidth: 100
        },
        disabled: disabled,
        tooltipProps: tooltipProps,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                weight: subtext ? 'normal' : 'light',
                children: text
            }),
            subtext && /*#__PURE__*/ _jsx(Typography, {
                children: subtext
            })
        ]
    }, value);
}
export function OccurrenceAndTriggerControls(param) {
    let { controls } = param;
    const { BillingInitiationControlTestIds, isMobileDevice, isDisabled, disabledReason, featureFlags, billingTriggersTexts, billingInitiationTexts, recurrencePeriodsTexts, occurrenceValue, triggerValue, oneTimeInStages, isYearly, isAutomaticOptionSelected, shouldShowYearlyManualTooltip, hasNonPercentageDiscountError, hasValueDiscount, isFixedPrice, shouldDisableInStagesOption, occurrenceOptions, triggerOptions, handleOccurrenceChange, handleTriggerChange } = controls;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                placement: "top",
                testId: BillingInitiationControlTestIds.Occurrence.Tooltip(),
                title: disabledReason === 'existingServiceInAgreement' ? billingTriggersTexts.tooltips.cannotModifyOccurrence() : hasNonPercentageDiscountError ? billingInitiationTexts.tooltips.mustBePercentage() : '',
                children: /*#__PURE__*/ _jsx(InlineSelect, {
                    bi: {
                        name: 'billing_occurrence'
                    },
                    skin: "primary",
                    value: occurrenceValue,
                    testId: BillingInitiationControlTestIds.Occurrence.Root(),
                    disabled: isDisabled,
                    error: hasNonPercentageDiscountError,
                    onChange: handleOccurrenceChange,
                    menuMaxHeight: 200,
                    SelectProps: {
                        renderValue: (value)=>getOccurrenceLabel(value, billingInitiationTexts, recurrencePeriodsTexts)
                    },
                    children: occurrenceOptions.map((param)=>{
                        let { value, text, disabled: optionDisabled } = param;
                        const isInStagesOption = value === 'inStages';
                        const isOnDemandOption = value === 'onDemand';
                        const isOptionDisabled = optionDisabled || isInStagesOption && shouldDisableInStagesOption;
                        const tooltipTitle = getOccurrenceOptionTooltip({
                            isInStagesOption,
                            isOnDemandOption,
                            isDisabled: isOptionDisabled,
                            hasValueDiscount,
                            isFixedPrice,
                            oneTimeInStages: !!oneTimeInStages,
                            t: billingInitiationTexts
                        });
                        return renderBillingInitiationMenuItem({
                            value,
                            text,
                            testId: BillingInitiationControlTestIds.Occurrence.Option(value),
                            disabled: isOptionDisabled,
                            isMobileDevice,
                            tooltipProps: tooltipTitle ? {
                                title: tooltipTitle,
                                placement: 'top'
                            } : undefined
                        });
                    })
                })
            }),
            !oneTimeInStages && /*#__PURE__*/ _jsx(Tooltip, {
                placement: "top",
                testId: BillingInitiationControlTestIds.Trigger.Tooltip(),
                title: disabledReason === 'existingServiceInAgreement' ? billingTriggersTexts.tooltips.cannotModifyTrigger() : shouldShowYearlyManualTooltip ? billingTriggersTexts.tooltips.yearlyServicesManualOnly() : '',
                children: /*#__PURE__*/ _jsx(InlineSelect, {
                    bi: {
                        name: 'billing_trigger'
                    },
                    skin: "primary",
                    value: triggerValue,
                    testId: BillingInitiationControlTestIds.Trigger.Root(),
                    disabled: isDisabled,
                    error: shouldShowYearlyManualTooltip,
                    onChange: handleTriggerChange,
                    menuMaxHeight: 500,
                    SelectProps: {
                        renderValue: (value)=>getTriggerLabel(value, billingInitiationTexts)
                    },
                    children: triggerOptions.map((param)=>{
                        let { value, text, subtext } = param;
                        const isAutomaticOption = value === 'approval' || value === 'ongoing';
                        const shouldDisableAutomaticOption = isYearly && !featureFlags.YEARLY_AUTOMATIC_SERVICE && isAutomaticOption;
                        return renderBillingInitiationMenuItem({
                            value,
                            text,
                            subtext,
                            testId: BillingInitiationControlTestIds.Trigger.Option(value),
                            disabled: shouldDisableAutomaticOption,
                            isMobileDevice,
                            tooltipProps: shouldDisableAutomaticOption && !isAutomaticOptionSelected ? {
                                title: billingTriggersTexts.tooltips.yearlyServicesManualOnly(),
                                placement: 'top'
                            } : undefined
                        });
                    })
                })
            })
        ]
    });
}
